/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PersonalReductionRequisitionFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    employeeId?: boolean;
    employeeName?: boolean;
    employeeEnrollment?: boolean;
    employeeCompany?: boolean;
    employeeDepartment?: boolean;
    employeeDepartmentId?: boolean;
    employeeArea?: boolean;
    transactionEffectiveDate?: boolean;
    movementType?: boolean;
    reason?: boolean;
    other?: boolean;
    token?: boolean;
    code?: boolean;
    companyId?: boolean;
    humanCapitalCompanyId?: boolean;
    statusId?: boolean;
    createdByUser?: boolean;
}

